export default {
    LOAD_SENTENCE: 'loadSentence'
};